export const load = () => ({
	title: 'A Guide To Installing Mullions For Your Indow Window Inserts',
	h1: 'A Guide To Installing Mullions For Your Indow Window Inserts',
	showTitle: false,
	breadcrumbs: false,
	headerPosition: 'relative',
});
